import type { LeaderboardClient } from "@yjsgames/leaderboard";
import type { GpgsPort } from "@yjsgames/gpgs-ports";

/**
 * Android 리더보드 클라이언트 — 기존 GpgsPort(PGS v2)를 재사용해 점수 제출(중복 네이티브 결선 회피).
 * port는 getter 주입 — createGpgs가 dynamic import로 네이티브 어댑터를 교체해도 최신 포트를 호출.
 * isAvailable은 포트 가용성(네이티브 Android에서 로그인 시 true)을 그대로 위임.
 */
export class GpgsLeaderboardClient implements LeaderboardClient {
  constructor(private readonly port: () => GpgsPort) {}

  isAvailable(): boolean {
    return this.port().isAvailable();
  }

  async submitScore(leaderboardId: string, score: number): Promise<void> {
    await this.port().submitLeaderboardScore(leaderboardId, score);
  }
}
